import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { UserProvider } from '@fff-web/fff-utilities';
import App from './Components/App/App';
import store from './store';
import { bootstrapLD } from './utils/launchDarkly/bootstrapLD';
import './globals.css';

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

(async () => {
  const container = document.querySelector('#root');
  const root = createRoot(container!);
  const { userData, LDProvider } = await bootstrapLD();

  root.render(
    <BrowserRouter>
      <LDProvider>
        <Provider store={store}>
          <UserProvider>
            <UniversalNavigationContextProvider>
              <App userData={userData} />
            </UniversalNavigationContextProvider>
          </UserProvider>
        </Provider>
      </LDProvider>
    </BrowserRouter>,
  );
})();
